





































































import Vue from 'vue';
import { errorToMessage } from '../../../core/utils/errors';
import RefreshData from '@/web/mixins/refreshData';
import { mapGetters } from 'vuex';
import StudioCommunityGroupTabs from '@/web/views/shop/StudioCommunityGroupTabs';
import { getConfig } from '@/web/utils/configuration';
import HMSearchModal from '@/web/components/common/HMSearchModal';
import { getStudioURL } from '@/web/router/custom-domain-utils';

export default Vue.extend({
  name: 'StudioCommunityGroup',
  mixins: [RefreshData],
  components: {
    StudioCommunityGroupTabs,
  },
  computed: {
    ...mapGetters({
      communityComments: 'community/comments',
      studioMembers: 'community/studioMembers',
      group: 'community/currentGroup',
    }),
    config() {
      return getConfig();
    },
    headerImage() {
      return this.group?.cover_photo;
    },
    // Return authors of root level comments only if they have a profile picture
    getMembers() {
      const members = [];
      (this.communityComments || []).forEach(comment => {
        if (comment.user?.image) {
          const user = {
            ...comment.user,
            name: comment.user.first_name + ' ' + comment.user.last_name,
          };
          if (!members.find(elem => comment.user.id == elem.id)) {
            members.push(user);
          }
        }
      });
      return members.slice(0, 5);
    },
  },
  data() {
    return {
      isLoading: true,
    };
  },
  methods: {
    async loadData() {
      this.isLoading = true;
      try {
        await this.$store.dispatch('community/loadStudioGroup', {
          studioURL: getStudioURL(this.$route),
          groupId: this.$route.params.group_id,
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR') as string,
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1,
        });
      } finally {
        this.isLoading = false;
      }
    },
    openSearchModal() {
      this.$modal.show(HMSearchModal, {
        onSearch: this.doSearch,
      });
    },
    doSearch(query) {
      this.$router.push({
        name: 'studio-community-feed',
        query: { query },
      });
    },
    onHashtag(hashtag) {
      this.$router.push({
        name: 'studio-community-feed',
        query: { query: hashtag },
      });
    },
  },
  async mounted() {
    await this.loadData();
  },
});
